import React, { useState, useEffect } from 'react';
import { 
  BrowserRouter as Router, 
  Routes, 
  Route,
  createRoutesFromElements
} from 'react-router-dom';
import HomePage from './HomePage';
import TrainingPage from './TrainingPage';
import ExplorationPage from './ExplorationPage';
import TopicDetailPage from './TopicDetailPage';
import PersonalProfilePage from './PersonalProfilePage';
import KnowledgeBasePage from './KnowledgeBasePage';
import LoginPage from './LoginPage';
import AccountCenter from './AccountCenter';
import { LanguageProvider } from './contexts/LanguageContext';
import './App.css';
import { logDeviceInfo } from './utils/deviceDetection';

function App() {
  const [userInfo, setUserInfo] = useState({
    username: '',
    avatarIndex: 0,
    learningLanguage: 'english',
    nativeLanguage: 'chinese',
    interfaceLanguage: 'en',
    currentScene: 'IELTS'
  });

  // 初始化用户信息
  useEffect(() => {
    setUserInfo({
      username: 'Guest',
      interfaceLanguage: 'en',
      currentScene: 'IELTS'
    });
  }, []);

  // 组件挂载时记录设备信息
  useEffect(() => {
    // 记录设备信息，用于调试
    logDeviceInfo();
  }, []);

  return (
    <LanguageProvider>
      <Router future={{ 
        v7_startTransition: true,
        v7_relativeSplatPath: true 
      }}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/profile" element={<PersonalProfilePage />} />
          <Route path="/account" element={<AccountCenter />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/knowledge" element={<KnowledgeBasePage />} />
          <Route path="/training" element={
            <TrainingPage 
              deadline={30}
              username={userInfo.username}
              purpose="IELTS"
            />
          } />
          <Route path="/exploration" element={<ExplorationPage />} />
          <Route path="/topic/:topicId" element={<TopicDetailPage />} />
        </Routes>
      </Router>
    </LanguageProvider>
  );
}

export default App;
